import clsx from 'clsx'
import {FC, useMemo} from 'react'
import {useIntl} from 'react-intl'
import {useAuth} from '../providers'
import {useLanguage} from '../i18n/Metronici18n'
import {LanguageConfig} from '../config'

type Props = {}

const Languages: FC<Props> = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()
  const {language, handleUpdateLanguage} = useLanguage()

  const currentLanguage = useMemo(() => {
    return LanguageConfig().LANGUAGES.find((x) => x.value === language) ?? null
  }, [language])

  const languages = useMemo(() => {
    return LanguageConfig().LANGUAGES
  }, [])

  return (
    <div className=''>
      <h6 className='mb-5 text-gray-800 fs-6 fw-bolder lh-1'>
        {intl.formatMessage({id: 'CHANGE_LANGUAGE'})}
      </h6>
      {languages?.map((l) => {
        return (
          <div
            className='text-hover-primary py-2'
            key={l.value}
            onClick={async () => {
              if (l.value !== language && currentUser) {
                await handleUpdateLanguage(l.value)
              }
            }}
          >
            <div
              className={clsx('d-flex', {
                'text-primary fw-bold': l.value === currentLanguage?.value,
              })}
            >
              <div className='d-flex gap-3 align-items-center'>
                <img className='w-15px h-15px rounded-1' src={l.flag} alt={l.label} />
                {intl.formatMessage({id: l.label})}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export {Languages}
